<template>
  <div class="share-setting-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="title">创建公司动态</div>
        <el-form
          :model="configure"
          label-width="110px"
          label-position="right"
          :rules="rules"
          ref="form"
          class="configure-form"
        >
          <el-form-item label="标题" prop="slogan" class="form-item">
            <el-input
              size="small"
              placeholder="请输入标题"
              class="input"
              v-model="configure.title"
              style="width: 270px"
              v-if="!id"
            ></el-input>
            <span v-else>
              {{ configure.title }}
            </span>
          </el-form-item>
          <el-form-item label="文章内容" prop="slogan" class="form-item">
            <WangEditor
              :text="configure.content"
              class="text"
              @change="changeText"
              v-if="!id"
            />
            <div style="padding-top: 8px;" v-else v-html="configure.content"></div>
          </el-form-item>
        </el-form>
        <!-- <div class="btn-box">
            <button class="btn" @click="handleShare">保存设置</button>
          </div> -->
      </div>
      <div class="btn-box" v-if="!id">
        <!-- <button class="cancel-btn" @click="handleCancel">取消</button> -->
        <button class="confirm-btn" @click="handleConfirm">创建动态</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import WangEditor from '../../components/common/wang-edit';
export default {
  components: {
    Header,
    WangEditor
  },
  name: 'share-setting',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '公司动态设置'
      },
      configure: {
        title: '',
        content: ''
      },
      rules: {},
      loading: 0
    };
  },
  mounted() {
    let query = this.$route.query;
    if(query.id){
      this.id = +query.id;
      this.getInfo();
    }
  },
  computed: {},
  methods: {
    // 获取分享详情
    getInfo() {
      this.loading++;
      this.httpGet(this.$root.getDynamicsInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          this.configure = {
            title: res.title,
            content: res.content,
          };
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeText(val) {
        // 文本更改
        this.configure.content = val;
    },
    // 保存修改
    handleShare() {
      
    },
    handleConfirm(){
      this.loading++;
      this.httpPost(this.$root.addDynamics, this.configure).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.$router.push({
            name: 'companyDynamics',
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.configure, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.img.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.share-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px;
      border-radius: 2px;

      .title {
        word(20px, #404157);
        font-weight: 550;
      }

      .configure-form {
        margin: 50px 80px 0;

        .input {
          width: 150px;
        }
      }

      .tip {
        word(15, #EA0000);
        margin-top: 24px;
        margin-left: 80px;
      }

      .btn-box {
        .btn {
          confirm-btn();
          width: 145px;
          height: 32px;
          margin-top: 24px;
          margin-left: 190px;
        }
      }

      .addImg {
        .tips {
          // margin-bottom: 12px;
          line-height: 40px;
        }

        .icon {
          width: 240px;
          height: 384px;
        }

        .img {
          width: 240px;
          height: auto;
        }

        p {
          margin: 0;
        }

        .tip {
          color: gray9;
        }
      }
    }
  }
  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
